import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { formatDistance } from 'date-fns'
import { truncate } from '../../../utils/string'
import Link from '../../../components/Link'
import SpamReporter from '../../../components/spam/spam_reporter'

export default class CommentListItem extends PureComponent {
  getReportSpamContent() {
    const { comment } = this.props
    if (comment.comment.match(/http/)) {
      return (
        <SpamReporter resourceName="Comment" resourceId={comment.id} className="button-reset comment__spam-reporter" />
      )
    }
    return null
  }

  getBylineContent() {
    const { comment } = this.props
    if (this.showAsDeleted()) {
      return <span>[Comment removed]</span>
    } else {
      const reportSpam = this.getReportSpamContent()
      const commentCreatedAt = new Date(comment.created_at)
      const timeAgoInWords = formatDistance(commentCreatedAt, new Date(), { addSuffix: true })
      const commenter = comment.user
      return (
        <span>
          <Link href={commenter.profile_link} title={`${commenter.display_name}'s profile page`}>
            {truncate(commenter.display_name)}
          </Link>{' '}
          <span className="comment__time-ago">{timeAgoInWords}</span>
          {reportSpam}
        </span>
      )
    }
  }

  getBodyContent() {
    const { comment } = this.props
    return this.showAsDeleted() ? 'This comment has been removed.' : comment.comment
  }

  showAsDeleted() {
    const { comment } = this.props
    return comment.spam_locked_at !== null
  }

  render() {
    const bylineContent = this.getBylineContent()
    const bodyContent = this.getBodyContent()
    return (
      <li className="comment" data-testid="qa-comment-list-item">
        <div className="comment__byline">{bylineContent}</div>
        <div className="comment__body" data-testid="qa-comment-text">
          {bodyContent}
        </div>
      </li>
    )
  }
}
CommentListItem.propTypes = {
  comment: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    user: PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      profile_link: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}
